import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Keyanalyzer saved our team weeks of research. We found the perfect project management tool in minutes.',
  author: 'Sarah Chen',
  role: 'Product Manager at TechFlow',
  rating: 5,
  avatar: 'SC'
}, {
  quote: 'The comparison features are incredible. Being able to see feature breakdowns side-by-side made the decision obvious.',
  author: 'Marcus Johnson',
  role: 'CTO at StartupX',
  rating: 5,
  avatar: 'MJ'
}, {
  quote: 'Finally, a platform that gives honest, community-driven insights without the marketing fluff. Highly recommended.',
  author: 'Elena Rodriguez',
  role: 'Freelance Designer',
  rating: 5,
  avatar: 'ER'
}];
export function SocialProof() {
  return <section className="py-24 bg-slate-900 text-white relative overflow-hidden" data-id="element-150">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-20 pointer-events-none" data-id="element-151">
        <div className="absolute top-0 right-0 w-96 h-96 bg-purple-600 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-152" />
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-blue-600 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" data-id="element-153" />
      </div>

      <div className="container mx-auto px-6 relative z-10" data-id="element-154">
        <div className="text-center mb-16" data-id="element-155">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-slate-800 border border-slate-700 text-sm text-slate-300 mb-6" data-id="element-156">
            <span className="flex gap-1" data-id="element-157">
              {[1, 2, 3, 4, 5].map(s => <Star key={s} className="w-3 h-3 text-yellow-400 fill-yellow-400" data-id="element-158" />)}
            </span>
            <span className="font-medium" data-id="element-159">10,000+ Reviews</span>
          </div>
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-160">
            Trusted by Industry Leaders
          </h2>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto" data-id="element-161">
            Join thousands of professionals who rely on Keyanalyzer to make
            informed software decisions.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-162">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} whileHover={{
          y: -5
        }} className="bg-slate-800/50 backdrop-blur-sm p-8 rounded-2xl border border-slate-700 hover:border-purple-500/50 transition-colors" data-id="element-163">
              <div className="flex gap-1 mb-6" data-id="element-164">
                {[...Array(testimonial.rating)].map((_, i) => <Star key={i} className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-165" />)}
              </div>
              <blockquote className="text-lg text-slate-200 mb-6 leading-relaxed" data-id="element-166">
                "{testimonial.quote}"
              </blockquote>
              <div className="flex items-center gap-4" data-id="element-167">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-purple-500 to-blue-500 flex items-center justify-center font-bold text-sm" data-id="element-168">
                  {testimonial.avatar}
                </div>
                <div data-id="element-169">
                  <div className="font-semibold text-white" data-id="element-170">
                    {testimonial.author}
                  </div>
                  <div className="text-sm text-slate-400" data-id="element-171">
                    {testimonial.role}
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}